import { Component } from '@angular/core';
import { Item } from 'src/app/models/item';
import { DashboardService } from 'src/app/services/dashboard.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-dashboard-distributor-panel',
  templateUrl: './dashboard-distributor-panel.component.html',
  styleUrls: ['./dashboard-distributor-panel.component.css']
})
export class DashboardDistributorPanelComponent {
  activeDistributor:number = 0;
  blockedDistributor:number = 0;
  onboardedDistributor:number = 0;

  topPerfDistributor:any=[];
  topRecentDistributor:any=[];

  graphdataDistributor: any[] = [];
  visibleColumnDataDistributor: Item[] = [];
  visibleColumnsIdDistributor:any[] = [];
  graphHeaderDistributor :any[]=[];
  constructor(private spinner: LoaderService, private dashboardSevice:DashboardService){

  }  

  GetTop5DistributorDashboardData(StartDate:string,EndDate:string,policyType:number){
    let obj={
      DistributorId:0,
      ResellerId:0,
      AgentId:0,
      SystemCompanyId:1,
      StartDate:StartDate,//moment(this.selectedStartDate).format('YYYY-MM-DD'),
      EndDate:EndDate,//moment(this.selectedEndDate).format('YYYY-MM-DD'),
      policyType:policyType//this.policyType
    }
    this.dashboardDistributorStatus(obj);
    this.dashboardSevice.GetTop5DistributorDashboardData(obj).then((response)=> { 
    if(response?.isSuccess && response?.result?.length > 0)
    {
      for(let i=0;i<response?.result?.length;i++)
      {
        if(response.result[0] != null && response.result[0] != undefined && response.result[0] != "")
        {
          switch(i)
          {case 0 :
              this.topRecentDistributor= JSON.parse(response.result[i]);            
            break;
            case 1 :
              this.topPerfDistributor= JSON.parse(response.result[i]);              
            break;
          }          
        }
      }

      if(this.topPerfDistributor && this.topPerfDistributor.length > 0)
      {
        this.graphHeaderDistributor=Object.keys(this.topPerfDistributor[0]).map((m:any)=>{return {key: m,type:"System.String"}});
        this.visibleColumnDataDistributor =  this.graphHeaderDistributor.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
        this.visibleColumnsIdDistributor = this.visibleColumnDataDistributor.map((m:any)=>{return m.id.toString()});
        this.graphdataDistributor=this.topPerfDistributor.map((m:any) => {return Object.values(m)});
      }
      else
      {
        this.graphHeaderDistributor = [];
        this.visibleColumnDataDistributor = [];
        this.visibleColumnsIdDistributor = [];
        this.graphdataDistributor = [];
      }  
      }
    });
  }

  async dashboardDistributorStatus(obj:any){
    this.dashboardSevice.DashboardDistributorStatus(obj).then((response)=> { 
      if(response?.isSuccess && response?.result?.length > 0)
      {
        for(let i=0;i<response?.result?.length;i++)
        {
          if(response.result[0] != null && response.result[0] != undefined && response.result[0] != "")
          {
            switch(i)
            {
              case 0 :
              this.onboardedDistributor= JSON.parse(response.result[i])[0].count;
              //let onBoardedAgentOld = JSON.parse(response.result[i])[1].count;
              //this. onBoardedAgentRatio = getGrowthRatio((onBoardedAgentOld??0).toString(),(this.onBoardedAgent??0).toString());
              break;
              case 1 :
              this.blockedDistributor= JSON.parse(response.result[i])[0].count;
              //let inProgressAgentOld= JSON.parse(response.result[i])[1].count;
              //this.inProgressAgentRatio = getGrowthRatio((inProgressAgentOld??0).toString(),(this.inProgressAgent??0).toString());
              break;
              case 2 :
              this.activeDistributor= JSON.parse(response.result[i])[0].count;
              break;
              // this.blokedAgent= JSON.parse(response.result[i])[0].count;
              // let blokedAgentOld= JSON.parse(response.result[i])[1].count;
              // //this.blokedAgentRatio = getGrowthRatio((blokedAgentOld??0).toString(),(this.blokedAgent??0).toString());
              // break;
              // case 3 :
              // this.totalCustomers= JSON.parse(response.result[i])[0].count;
              // let totalCustomersOld = JSON.parse(response.result[i])[1].count;
              // //this.totalCustomersRatio = getGrowthRatio((totalCustomersOld??0).toString(),(this.totalCustomers??0).toString());
              // break;
            }
            
          }
        } 
      }
    });
  }
}
